import { InjectionToken } from '@angular/core';
import { ContentHandlerInterface } from '@core/content-handlers/content-handler.interface';

export const CONTENT_HANDLERS_INJECTION_TOKEN =
  new InjectionToken<ContentHandlerInterface[]>('CONTENT_HANDLERS_INJECTION_TOKEN');
